import Modal from 'react-modal';
import { useFirestoreOrderBy } from '../../firebase/useFirestore';

const AddCustomEventsModal = ({
  setAddCustomEventsModalOpen,
  addCustomEventsModalOpen,
  addCustomEvents,
  selectedCustomEvents,
  setSelectedCustomEvents
}) => {
  // Firestore
 const customEvents = useFirestoreOrderBy('CustomEventFields', 'Position', 'asc');

  // Modal settings
  Modal.setAppElement('#root');

  const modalStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };

  const isGroupSelected = (groupId) =>
    selectedCustomEvents.some((g) => g.ID === groupId);

  const handleToggleGroup = (group) => {
    setSelectedCustomEvents((prev) => {
      const alreadySelected = prev.some((g) => g.ID === group.ID);
      if (alreadySelected) {
        // remove
        return prev.filter((g) => g.ID !== group.ID);
      }
      // add
      return [...prev, group];
    });
  };

  const allSelected =
    customEvents &&
    customEvents.length > 0 &&
    customEvents.every((tg) =>
      selectedCustomEvents.some((sel) => sel.ID === tg.ID)
    );

  const handleToggleAll = () => {
    if (!customEvents || customEvents.length === 0) return;
    if (allSelected) {
      // deselect all
      setSelectedCustomEvents([]);
    } else {
      // select all
      setSelectedCustomEvents(customEvents);
    }
  };

  return (
    <Modal
      isOpen={addCustomEventsModalOpen}
      onRequestClose={() => setAddCustomEventsModalOpen(false)}
      style={modalStyles}
      contentLabel="Add custom events Modal"
    >
      <div>
        <div id="delete-modal-text-container">
          <h1>Custom veld synchroniseren</h1>
          <h2>Selecteer de custom velden die u wilt synchroniseren</h2>

          {/* Individual custom events */}
          {customEvents && customEvents.length > 0 &&
            customEvents.map((event) => (
              <div
                key={event.ID}
                id="portfolio-syncs-add-targetgroup-modal-effects-container"
              >
                <input
                  type="checkbox"
                  id={`tg-${event.ID}`}
                  checked={isGroupSelected(event.ID)}
                  onChange={() => handleToggleGroup(event)}
                />
                <label htmlFor={`tg-${event.ID}`}>
                  {event.Title}
                </label>
              </div>
            ))}

          {customEvents && customEvents.length === 0 && (
            <p>Er zijn nog geen custom velden beschikbaar om te synchroniseren.</p>
          )}
        </div>

        <div id="delete-modal-button-container">
          <button
            id="delete-modal-delete-button"
            onClick={() => setAddCustomEventsModalOpen(false)}
          >
            Annuleren
          </button>
          <button onClick={addCustomEvents}>
            Opslaan
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default AddCustomEventsModal;
